import { SemanticCOLORS, Label } from 'semantic-ui-react';
import { serverToLocalDate } from '../../../../utils/dateTimeUtils';
import { TaskStatusType } from '../../../../schemas/task.schemas';
import { TASK_STATUS } from '../../../../constnats/task';
type DueDatePropsType = {
    date: string;
    status:TaskStatusType
};

function TaskDueDate({ date, status }: DueDatePropsType) {
    const currentTime = Date.now();
    const parsedDate = new Date(date);
    const passedDays = (currentTime - parsedDate.getTime()) / (1000 * 60 * 60 * 24);
    const color: SemanticCOLORS = (passedDays >= 1 && status !== TASK_STATUS.COMPLETED) ? 'red' : 'grey';
    return <Label color={color}>{serverToLocalDate(parsedDate.getTime())}</Label>;
}
export default TaskDueDate;
